import * as React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Translate } from '../../../../../shared/LanguageService';
import Dropzone from '../../../../../components/common/Dropzone';

interface IProps {
    title: string;
    dropzoneId: string;
    actionUrl: string;
    upload: boolean;
    onUploadCompleted: () => void;
    onFileUploadCompleted: (response: any) => void;

    onUpload: () => void;
    closeModal: () => void;
}

const AnnotationFilesUploadModal = (props: IProps) => {
    return (
        <Modal
            show={true}
            onHide={props.closeModal}
            bsSize="large"
            autoFocus={false}
            enforceFocus={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Dropzone
                    dropzoneHtmlId={props.dropzoneId}
                    actionUrl={props.actionUrl}
                    upload={props.upload}
                    onUploadCompleted={props.onUploadCompleted}
                    onFileUploadCompleted={props.onFileUploadCompleted}
                    uploadMultiple={true}
                    removeFileAfterSuccess={true}
                    acceptedFiles={'application/pdf,image/jpeg,image/png,image/gif'}
                ></Dropzone>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.closeModal}>
                    {Translate('order/plan/modal/close-button')}
                </Button>
                <Button bsStyle="info" className="pull-right" onClick={props.onUpload}>
                    <i className="material-icons md-18">cloud_upload</i>{' '}
                    {Translate('order/plan/upload-button')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AnnotationFilesUploadModal;
